import { render, staticRenderFns } from "./prepare-invitation.vue?vue&type=template&id=1f0884e2&scoped=true&"
import script from "./prepare-invitation.vue?vue&type=script&lang=js&"
export * from "./prepare-invitation.vue?vue&type=script&lang=js&"
import style0 from "./prepare-invitation.vue?vue&type=style&index=0&id=1f0884e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0884e2",
  null
  
)

export default component.exports